import Reveal from "./Reveal";
import { ArrowLeftRight, BarChart3, Users, ScanSearch, Globe2, Compass } from "lucide-react";

const SERVICES = [
  {
    icon: ArrowLeftRight,
    title: "Import–Export Intelligence",
    text: "Clear visibility into import–export activity, trade flows and counterparties across markets.",
  },
  {
    icon: BarChart3,
    title: "Business & Trade Analytics",
    text: "Structured analysis of business and trade data, translated into insight you can act on.",
  },
  {
    icon: Users,
    title: "Buyer–Supplier Research",
    text: "Research that maps buyers and suppliers, supporting sourcing and partnership decisions.",
  },
  {
    icon: ScanSearch,
    title: "Competitor Intelligence",
    text: "A grounded view of the competitive landscape to inform positioning and strategy.",
  },
  {
    icon: Globe2,
    title: "Market Research & Insights",
    text: "Research that explains market demand, dynamics and direction with clarity.",
  },
  {
    icon: Compass,
    title: "Strategic Business Intelligence",
    text: "Integrated intelligence that supports planning, prioritisation and long-term growth.",
  },
];

export default function Expertise() {
  return (
    <section id="expertise" className="relative bg-mist py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="eyebrow">Our Expertise</p>
          <h2 className="font-display text-3xl font-light leading-tight text-navy-900 sm:text-4xl lg:text-[2.75rem]">
            Focused expertise across the trade intelligence spectrum.
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={0.07 * i} className="h-full">
              <article
                data-testid={`expertise-card-${i}`}
                className="group relative flex h-full flex-col rounded-2xl border border-navy-900/8 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-royal/30 hover:shadow-[0_20px_50px_rgba(10,30,66,0.10)]"
              >
                <span className="absolute right-7 top-7 font-display text-sm text-navy-900/20">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-royal/15 bg-royal/5 text-royal transition-colors duration-300 group-hover:bg-royal group-hover:text-white">
                  <s.icon className="h-5 w-5" strokeWidth={1.6} />
                </span>
                <h3 className="mt-6 font-display text-xl leading-snug text-navy-900">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-navy-900/60">{s.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
